<script>
  /* global Global */
  import Header from '../common/Header.svelte';
  import IconButton from '../common/IconButton.svelte';

  let lang;
  let mode;

  function switchLanguage () {
    lang = lang !== 'en' ? 'en' : 'cs';
    window.localStorage.setItem('lang', lang);
  }

  function switchMode () {
    mode = mode !== 'light' ? 'light' : 'dark';
    window.localStorage.setItem('mode', mode);

    window.document.body.classList.toggle('dark');
    document.querySelector('meta[name="theme-color"]').setAttribute('content', mode !== 'dark' ? Global.color.primary : Global.color.primaryDark);
  }

  function back () {
    window.location.href = window.localStorage.getItem('previousPage') || './';
  }

  const i18n = {
    pageTitle: {
      cs: `Stránka nenalezena | ${Global.project.name.cs}`,
      en: `Page not found | ${Global.project.name.en}`,
    },
    notFound: {
      cs: 'Stránka nenalezena',
      en: 'Page not found',
    },
  };

  const projectName = Global.project.name;
  const projectLogo = Global.project.logo;
</script>

<svelte:head>
  <title> {i18n.pageTitle[lang]} </title>
</svelte:head>

<Header page='not-found' display={false} savePage={false} bind:lang/>

<div class='not-found'>
  <div class='not-found-logo'>
    <img class='not-found-logo-image' src='img/static/{projectLogo}.svg' alt='{projectName[lang]} logo'/>
  </div>

  <div class='not-found-title'>
    <div class='not-found-title-box'>
      <div class='not-found-title-box-actions'>
        <IconButton icon='translate' onClick={switchLanguage} borderRadius='5px'/>

        <IconButton icon={mode !== 'dark' ? 'dark_mode' : 'light_mode'} onClick={switchMode} borderRadius='5px'/>

        <IconButton icon='arrow_back' onClick={back} borderRadius='5px'/>
      </div>

      <div class='not-found-title-box-title'>
        <div class='not-found-title-box-title-text'>
          {i18n.notFound[lang]}
        </div>
      </div>
    </div>
  </div>
</div>

<style>
  .not-found {
    position: fixed;
    top: 0px;
    left: 0px;

    display: flex;

    width: 100%;
    height: 100%;

    z-index: 3;

    background: var(--primary);
  }

  .not-found-logo {
    display: flex;
    align-items: center;
    flex-grow: 1;

    width: calc(100% - 450px);

    padding: 7.5%;
  }

  .not-found-logo-image {
    width: 100%;
    height: 100%;
  }

  .not-found-title {
    flex-shrink: 0;

    width: 100%;
    height: 100%;
    max-width: 450px;

    background: var(--white);
  }

  .not-found-title-box {
    height: calc(100% - 40px);

    padding: 20px;
  }

  .not-found-title-box-actions {
    position: absolute;
    top: 20px;
    right: 20px;

    display: flex;
    gap: 10px;
  }

  .not-found-title-box-title {
    display: flex;
    align-items: center;

    width: 100%;
    height: 100%;

    font-family: var(--font-secondary);
    font-size: 48px;
    font-weight: bold;
  }

  :global(body.dark) .not-found {
    background: var(--primary-dark);
  }

  :global(body.dark) .not-found-logo {
    filter: brightness(88%);
  }

  :global(body.dark) .not-found-title {
    background: var(--grey-9);
  }

  @media only screen and (max-width: 900px) {
    .not-found-logo {
      display: none;
    }

    .not-found-title {
      max-width: 100%;
    }
  }
</style>
